// @flow

import Input from './input';
import ReduxFormInput from './input.reduxform';

export {
  ReduxFormInput,
};

export default Input;
